module.exports = __webpack_public_path__ + "img/full7-min.a79614af.png";